<template>
    <div>
        <div class="title">联系我们<span></span></div>
        <div class="jie">
        <div class="dp" v-for="(item,i) of data" :key="i">
            <p>{{item.title}}</p>
            <p v-for="(itemm,m) of item.xi" :key="m">{{itemm.t1}}</p>
            <p style="margin-top:50px;">关注我们</p>
            <p>
                <img src="http://upload.lusenky.com/upload/we/image.png" alt="" style="width:143px;height:143px;">
            </p>
        </div>
    </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            data:[
                {title:'北京华工恒达科技有限公司',xi:[{t1:'Beijing  Huagong  Hengda  Technology  Co.,  Ltd'},{t1:'全国服务热线：010-56268817（8:30-18:00）'},{t1:'24小时销售热线：13391633268'},{t1:'邮箱：market@hghdsc.com'},{t1:'地址：北京市房山区天星街1号院14号楼1206室'}]}
            ]
        }
    }
}
</script>
<style scoped>
    .title{
        width: 148px;
        height: 45px;
        background: rgba(230,0,18,1);
        color: #fff;
        font-size: 24px;
        text-align: left;
        line-height: 45px;
        padding-left: 29px;
        font-weight: bold;
        position: relative;
    }
    .title>span{
        display: inline-block;
        width: 70px;
        height: 45px;
        background: #fff;
        right: -53px;
        border-bottom:3px solid rgba(230,0,18,1);
        position: absolute;
        -webkit-transform: skewX(45deg);
        transform: skewX(37deg);
    }
.jie{
    padding: 30px;
    border-top: 3px solid rgba(230,0,18,1);
    background:rgba(237,237,237,1);
}
.jie>pre{
    font-size: 17px;
}
.dp{
    width: 400px;
    border-bottom:1px solid rgba(225,225,225,1);
}
.dp>p{
    font-size:14px;
font-weight:400;
color:rgba(89,87,87,1);
margin:15px 0;
}
.dp>p:first-child{
   font-size: 16px;
   color: #000;
}
</style>